import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'bankTransactions'

export const LIST_TRANSACTIONS_REQUEST = `${prefix}/LIST_TRANSACTIONS_REQUEST`
export const LIST_TRANSACTIONS_SUCCESS = `${prefix}/LIST_TRANSACTIONS_SUCCESS`
export const LIST_TRANSACTIONS_FAILURE = `${prefix}/LIST_TRANSACTIONS_FAILURE`

export const listBankTransactions = createAction((params: object) => ({
  type: [LIST_TRANSACTIONS_REQUEST, LIST_TRANSACTIONS_SUCCESS, LIST_TRANSACTIONS_FAILURE],
  promise: (api: IApi) => api.bankTransactions.listTransactions(params),
  params,
}))

export const UPDATE_TRANSACTIONS_REQUEST = `${prefix}/UPDATE_TRANSACTIONS_REQUEST`
export const UPDATE_TRANSACTIONS_SUCCESS = `${prefix}/UPDATE_TRANSACTIONS_SUCCESS`
export const UPDATE_TRANSACTIONS_FAILURE = `${prefix}/UPDATE_TRANSACTIONS_FAILURE`

export const updateTransactions = createAction((data: object) => ({
  type: [UPDATE_TRANSACTIONS_REQUEST, UPDATE_TRANSACTIONS_SUCCESS, UPDATE_TRANSACTIONS_FAILURE],
  promise: (api: IApi) => api.bankTransactions.updateTransactions(data),
}))

export const RETRY_PREDICTIONS = createRequestTypes(prefix, 'RETRY_PREDICTIONS')

/** Re-run Atlas's mapping pass for the client behind the transactions screen. */
export const retryPredictions = createAction((data: object) => ({
  type: RETRY_PREDICTIONS,
  promise: (api: IApi) => api.bankTransactions.retryPredictions(data),
}))

export const LIST_TRANSACTION_DETAIL_REQUEST = `${prefix}/LIST_TRANSACTION_DETAIL_REQUEST`
export const LIST_TRANSACTION_DETAIL_SUCCESS = `${prefix}/LIST_TRANSACTION_DETAIL_SUCCESS`
export const LIST_TRANSACTION_DETAIL_FAILURE = `${prefix}/LIST_TRANSACTION_DETAIL_FAILURE`

export const listBankTransactionDetail = createAction((params: object) => ({
  type: [
    LIST_TRANSACTION_DETAIL_REQUEST,
    LIST_TRANSACTION_DETAIL_SUCCESS,
    LIST_TRANSACTION_DETAIL_FAILURE,
  ],
  promise: (api: IApi) => api.bankTransactions.listBankTransactionDetail(params),
  params,
}))

export const LIST_TRANSACTION_RAW = createRequestTypes(prefix, `LIST_TRANSACTION_RAW`)
export const [LIST_TRANSACTION_RAW_REQUEST] = LIST_TRANSACTION_RAW

export const listBankTransactionsRaw = createAction((params: object) => ({
  type: LIST_TRANSACTION_RAW,
  promise: (api: IApi) => api.bankTransactions.listBankTransactionsRaw(params),
  params,
}))

const EXPORT_BANK_TRANSACTIONS = createRequestTypes(prefix, 'EXPORT_BANK_TRANSACTIONS')
export const [
  EXPORT_BANK_TRANSACTIONS_REQUEST,
  EXPORT_BANK_TRANSACTIONS_SUCCESS,
  EXPORT_BANK_TRANSACTIONS_FAILURE,
] = EXPORT_BANK_TRANSACTIONS

export const exportBankTransactions = createAction((params: object) => ({
  type: [
    EXPORT_BANK_TRANSACTIONS_REQUEST,
    EXPORT_BANK_TRANSACTIONS_SUCCESS,
    EXPORT_BANK_TRANSACTIONS_FAILURE,
  ],
  promise: (api: IApi) =>
    api.bankTransactions.listBankTransactionsRaw({
      ...params,
      isFile: true,
    }),
  params,
}))

export const LIST_TRANSACTION_GRAPH = createRequestTypes(prefix, `LIST_TRANSACTION_GRAPH`)
export const [LIST_TRANSACTION_GRAPH_REQUEST] = LIST_TRANSACTION_GRAPH

export const listBankTransactionsGraph = createAction((params: object) => ({
  type: LIST_TRANSACTION_GRAPH,
  promise: (api: IApi) => api.bankTransactions.listBankTransactionsGraph(params),
  params,
}))

export const HIDE_TRANSACTIONS = `${prefix}/HIDE_TRANSACTIONS`

export const hideBankTransactionsData = () => ({
  type: HIDE_TRANSACTIONS,
})

export const PROCESS_BANK_TRANSACTIONS = createRequestTypes(prefix, 'PROCESS_BANK_TRANSACTIONS')
export const [
  PROCESS_BANK_TRANSACTIONS_REQUEST,
  PROCESS_BANK_TRANSACTIONS_SUCCESS,
  PROCESS_BANK_TRANSACTIONS_FAILURE,
] = PROCESS_BANK_TRANSACTIONS

export const processBankTransactions = createAction((params: object) => ({
  type: PROCESS_BANK_TRANSACTIONS,
  promise: (api: IApi) => api.bankTransactions.processBankTransactions(params),
}))

export const MAP_BANK_ACCOUNT = createRequestTypes(prefix, 'MAP_BANK_ACCOUNT')
export const [MAP_BANK_ACCOUNT_REQUEST, MAP_BANK_ACCOUNT_SUCCESS, MAP_BANK_ACCOUNT_FAILURE] =
  MAP_BANK_ACCOUNT

export const mapBankAccount = createAction((params: object) => ({
  type: MAP_BANK_ACCOUNT,
  promise: (api: IApi) => api.bankTransactions.mapBankAccount(params),
}))

export const REJECT_PREDICTED_CATEGORY = createRequestTypes(prefix, 'REJECT_PREDICTED_CATEGORY')

export const rejectPredictedCategory = createAction((data: object) => ({
  type: REJECT_PREDICTED_CATEGORY,
  promise: (api: IApi) => api.bankTransactions.rejectPredictedCategory(data),
}))

export const UNREJECT_PREDICTED_CATEGORY = createRequestTypes(prefix, 'UNREJECT_PREDICTED_CATEGORY')

export const unrejectPredictedCategory = createAction((data: object) => ({
  type: UNREJECT_PREDICTED_CATEGORY,
  promise: (api: IApi) => api.bankTransactions.unrejectPredictedCategory(data),
}))
